import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { map } from 'lodash'

import Loader from 'components/Loader'
import DesktopFilters from 'components/PendingRefundsList/Filters/DesktopFilters'
import MobileFilters from 'components/PendingRefundsList/Filters//MobileFilters'

import { setRefundOrdersFilter } from 'store/Orders/actions'
import { getRevenueCenters } from 'store/RevenueCenters/selectors'
import {
  getIsLoadingRefundOrders,
  getRefundOrdersFilteredByRevenueCenterUuid,
} from 'store/Orders/selector'

const ListFilters = () => {
  const [isMobileFiltersModal, showMobileFiltersModal] = useState(false)

  const dispatch = useDispatch()

  const revenueCenters = useSelector(getRevenueCenters)
  const revenueCenterFilterValue = useSelector(
    getRefundOrdersFilteredByRevenueCenterUuid
  )
  const isLoading = useSelector(getIsLoadingRefundOrders)

  const transformedRevenueCenters = map(revenueCenters, ({ name, uuid }) => ({
    name,
    uuid,
  }))

  const handleSetSearchQuery = (event) => {
    dispatch(
      setRefundOrdersFilter({
        [event.target.id]: event.target.value,
      })
    )
  }

  const handleSetFilter = (filter) => (value) => {
    dispatch(
      setRefundOrdersFilter({
        [filter]: value,
      })
    )
  }

  const onClickFilterBtn = () => {
    showMobileFiltersModal(true)
  }

  const onCloseModal = () => {
    showMobileFiltersModal(false)
  }

  if (isMobileFiltersModal) {
    return isLoading ? (
      <Loader />
    ) : (
      <MobileFilters
        onCloseModal={onCloseModal}
        handleSetFilter={handleSetFilter}
        revenueCenterFilterValue={revenueCenterFilterValue}
        transformedRevenueCenters={transformedRevenueCenters}
      />
    )
  } else {
    return (
      <DesktopFilters
        handleSetFilter={handleSetFilter}
        transformedRevenueCenters={transformedRevenueCenters}
        handleSetSearchQuery={handleSetSearchQuery}
        onClickFilterBtn={onClickFilterBtn}
      />
    )
  }
}
export default ListFilters
